var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToBeConfirmEventsCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1249_2962)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.8085 2.94385C17.1508 2.95668 18.4192 3.06002 19.2469 3.88192C20.1932 4.82192 20.1932 6.33478 20.1932 9.3605V15.7791C20.1932 18.8048 20.1932 20.3176 19.2469 21.2576C18.3006 22.1976 16.7776 22.1976 13.7317 22.1976H7.27013C4.22416 22.1976 2.70118 22.1976 1.75489 21.2576C0.808594 20.3176 0.808594 18.8048 0.808594 15.7791V9.3605C0.808594 6.33478 0.808594 4.82192 1.75489 3.88192C2.58229 3.06002 3.85101 2.95668 6.19332 2.94385",
    stroke: "#FB943A",
    strokeMiterlimit: 133.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11523 14.1743H13.7307",
    stroke: "#FB943A",
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.11523 17.9185H11.0382",
    stroke: "#FB943A",
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19336 2.40689C6.19336 1.52081 6.91673 0.802246 7.80874 0.802246H13.1935C14.0855 0.802246 14.8089 1.52081 14.8089 2.40689V3.47655C14.8089 4.36263 14.0855 5.08119 13.1935 5.08119H7.80874C6.91673 5.08119 6.19336 4.36263 6.19336 3.47655V2.40689Z",
    stroke: "#FB943A",
    strokeMiterlimit: 133.33
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1249_2962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToBeConfirmEventsCardIcon);
export default __webpack_public_path__ + "static/media/to-be-confirm-events-card-icon.1758a4dc56c2748eadb6e34a3721afe9.svg";
export { ForwardRef as ReactComponent };